// @ts-nocheck
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOneOnOneNotesOfAssignee,
  updateNotesStatusAction,
} from "../../../store/actions/notifications";
import {
  Button,
  CircularProgress,
  ClickAwayListener,
  Tooltip,
  Typography,
  useMediaQuery,
  Chip,
  Badge,
  Box,
} from "@mui/material";
import { EventNotesNotification } from "../../../assets/svgs/SVGs";
import EventNotesPositionModal from "../components/EventNotesPositionModal";
import { USER_ROLES } from "../../../staticData/userRoles";
import { isUserRole, isActiveRole } from "../../../utils/methods/storeFunc";
import { useNavigate } from "react-router-dom";
import NotesBadge from "./NotesBadge";
const EventNotesNotificationTooltip = () => {
  const dispatch = useDispatch();
  const auth = useSelector((store) => store.auth);
  const userRole = useSelector((state) => state.auth.user?.role);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { updatedChatMetaData } = useSelector((state) => state.notifications);
  const [showNotificationNote, setShowNotificationNote] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [positionOpen, setPositionOpen] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState("");
  const handlePositionOpen = () => setPositionOpen(true);
  const handlePositionClose = () => setPositionOpen(false);
  //fetchOneOnOneNotesOfAssignee(create note notification api)
  useEffect(() => {
    dispatch(
      fetchOneOnOneNotesOfAssignee({
        // payload: {
        //   params: { eventId: eventInfo?._id }
        // },
        successCallback: (response) => {},
      }),
    );
  }, [dispatch]);

  // const LastActivity = ({ lastActivityAt }) => {
  //   const formatDateTime = (isoString) => {
  //     const date = new Date(isoString);

  //     const datePart = date.toLocaleDateString("en-US", {
  //       month: "long",
  //       day: "2-digit",
  //       year: "numeric",
  //     });

  //     const timePart = date.toLocaleTimeString("en-US", {
  //       hour: "numeric",
  //       minute: "2-digit",
  //       hour12: true,
  //     });

  //     return `Last activity: ${datePart} - ${timePart}`;
  //   };

  //   return (
  //     <div>
  //       {formatDateTime(lastActivityAt)}
  //     </div>
  //   );
  // };
  const LastActivity = ({ lastActivityAt }) => {
    const formatDateTime = (isoString) => {
      const date = new Date(isoString);

      const datePart = date.toLocaleDateString("en-US", {
        month: "long",
        day: "2-digit",
        year: "numeric",
      });

      const timePart = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      return `Last activity: ${datePart} - ${timePart}`;
    };

    return <div>{formatDateTime(lastActivityAt)}</div>;
  };
  const unReadNotification = useMemo(() => {
    const totalUnread = updatedChatMetaData?.reduce(
      (sum, data) => ({
        unread: sum?.unread + (data?.unreadMsgCount || 0),
        assigned: sum?.assigned + (data?.newAssigneeNoteCount || 0),
      }),
      { unread: 0, assigned: 0 },
    );
    return totalUnread || { unread: 0, assigned: 0 };
  }, [updatedChatMetaData]);
  const handleNavigation = (eventItem) => {
    const { positionIds, approved, isEstimateGenerated, eventId } = eventItem;
    if (isUserRole(userRole, USER_ROLES.CONTRACTOR)) {
      if (
        !positionIds ||
        !positionIds.positions ||
        positionIds.positions.length === 0
      )
        return;
    }
    let path = "";
    if (!approved && !isEstimateGenerated) {
      path = "/event/new-request/details";
    } else if (!approved && isEstimateGenerated) {
      path = "/event/estimates/view";
    } else if (approved && isEstimateGenerated) {
      path = "/event/details";
    }
    if (path) {
      navigate(path, { state: { id: eventId } });
      dispatch(updateNotesStatusAction({ status: true }));
    }
  };

  const shouldShowNotes = useMemo(() => {
    if (isActiveRole(USER_ROLES.CLIENT)) {
      if (auth?.isApproved) return true;
      else return false;
    } else if (isActiveRole(USER_ROLES.CONTRACTOR)) {
      if (unReadNotification?.unread > 0) return true;
      else return false;
    } else {
      return true;
    }
  }, [auth?.isApproved, unReadNotification?.unread]);

  return (
    <>
      <ClickAwayListener
        onClickAway={() => {
          setShowNotificationNote(false);
        }}
      >
        <Tooltip
          open={showNotificationNote}
          onClose={() => setShowNotificationNote(true)}
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: "1000px",
                border: "2px solid #D175B6",
                borderRadius: "16px",
                padding: "12px 2px 12px 12px",
                boxShadow:
                  "0px 0px 60px 0px #000000, 0px 0px 200px 0px #000000",
              },
            },
          }}
          title={
            <>
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                <Box
                  sx={{
                    width: "26.875em",
                    maxHeight: { xs: "60vh", md: "50vh", lg: "40vh" },
                    overflowY: "auto",
                    padding: "0 12px 0 0",
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#1a1a1a",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#D175B6",
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Typography
                    fontWeight="500"
                    fontSize="1.25rem"
                    color="#FFFFFF"
                    sx={{ textAlign: "center" }}
                  >
                    NOTES
                  </Typography>
                  {/* <ReusableParentContainer style={{ width: "100%", }}> */}
                  {updatedChatMetaData?.map((notes) => {
                    const formatDateTime = (isoString) => {
                      const date = new Date(isoString);
                      const datePart = date.toLocaleDateString("en-US", {
                        month: "long",
                        day: "2-digit",
                        year: "numeric",
                      });
                      const timePart = date.toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      });
                      return `${datePart} - ${timePart}`;
                    };
                    const formatDateOnly = (isoString) => {
                      const date = new Date(isoString);
                      return date.toLocaleDateString("en-US", {
                        month: "long",
                        day: "2-digit",
                        year: "numeric",
                      });
                    };
                    return (
                      <Box key={notes.eventId}>
                        <Typography
                          fontWeight="300"
                          fontSize="0.75rem"
                          color="#FFFFFF"
                          sx={{
                            textAlign: "center",
                            textShadow: "0px 0px 40px 0px #FFFFFF4D",
                            padding: "10px 15px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {formatDateOnly(notes.lastActivityAt)}
                          {/* {isUserRole(userRole, USER_ROLES.CONTRACTOR) && (
                        <span onClick={handlePositionOpen} style={{ cursor: 'pointer' }}>
                          <SmallEyeIcon />
                        </span>
                      )} */}
                        </Typography>
                        {isUserRole(userRole, USER_ROLES.CONTRACTOR) ? (
                          <Box
                            onClick={() => {
                              setSelectedEventId(notes.eventId);
                              handlePositionOpen();
                            }}
                            sx={{
                              width: "100%",
                              borderRadius: "5px",
                              padding: "10px",
                              background: "#FFFFFF1A",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                fontWeight="400"
                                fontSize="1.25rem"
                                sx={{
                                  cursor: "pointer",
                                  width: "44%",
                                  margin: "auto",
                                  fontWeight: 400,
                                  fontSize: "1.25rem",
                                  containerType: "inline-size",
                                }}
                                onClick={() => {
                                  if (
                                    !isUserRole(userRole, USER_ROLES.CONTRACTOR)
                                  ) {
                                    handleNavigation(notes);
                                  }
                                }}
                              >
                                {notes.eventName}
                              </Typography>
                              <Typography fontWeight="300" fontSize="0.75rem">
                                Last activity:
                                <span
                                  style={{
                                    fontWeight: 500,
                                    fontSize: "0.75rem",
                                  }}
                                >
                                  {formatDateTime(notes.lastActivityAt)}
                                </span>
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography fontWeight="300" fontSize="0.875rem">
                                Total Unread Comments:
                                <span
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  {notes.unreadMsgCount}
                                </span>
                              </Typography>
                              {notes?.newAssigneeNoteCount >= 1 && (
                                <Chip
                                  label={
                                    <span
                                      style={{
                                        fontWeight: 700,
                                        fontSize: "0.75rem",
                                        color: "#FFFFFF",
                                      }}
                                    >
                                      {notes.newAssigneeNoteCount}{" "}
                                      <span
                                        style={{
                                          fontWeight: 400,
                                          fontSize: "0.75rem",
                                        }}
                                      >
                                        New Assigned
                                      </span>
                                    </span>
                                  }
                                  size="small"
                                  sx={{
                                    background: "#D175B6",
                                    borderRadius: "40px",
                                    padding: "4px 8px",
                                  }}
                                />
                              )}
                            </Box>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              width: "100%",
                              borderRadius: "5px",
                              padding: "10px",
                              background: "#FFFFFF1A",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                fontWeight="400"
                                fontSize="1.25rem"
                                sx={{
                                  cursor: "pointer",
                                  width: "44%",
                                  margin: "auto",
                                  fontWeight: 400,
                                  fontSize: "1.25rem",
                                  containerType: "inline-size",
                                }}
                                onClick={() => {
                                  if (
                                    !isUserRole(userRole, USER_ROLES.CONTRACTOR)
                                  ) {
                                    handleNavigation(notes);
                                  }
                                }}
                              >
                                {notes.eventName}
                              </Typography>
                              <Typography fontWeight="300" fontSize="0.75rem">
                                Last activity:
                                <span
                                  style={{
                                    fontWeight: 500,
                                    fontSize: "0.75rem",
                                  }}
                                >
                                  {formatDateTime(notes.lastActivityAt)}
                                </span>
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography fontWeight="300" fontSize="0.875rem">
                                Total Unread Comments:
                                <span
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  {notes.unreadMsgCount}
                                </span>
                              </Typography>
                              {notes?.newAssigneeNoteCount >= 1 && (
                                <Chip
                                  label={
                                    <span
                                      style={{
                                        fontWeight: 700,
                                        fontSize: "0.75rem",
                                        color: "#FFFFFF",
                                      }}
                                    >
                                      {notes.newAssigneeNoteCount}{" "}
                                      <span
                                        style={{
                                          fontWeight: 400,
                                          fontSize: "0.75rem",
                                        }}
                                      >
                                        New Assigned
                                      </span>
                                    </span>
                                  }
                                  size="small"
                                  sx={{
                                    background: "#D175B6",
                                    borderRadius: "40px",
                                    padding: "4px 8px",
                                  }}
                                />
                              )}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                  {/* </ReusableParentContainer>  */}
                </Box>
              )}
            </>
          }
          arrow
        >
          <Box
            sx={{
              lineHeight: "0",
              marginRight: isSmallScreen ? "12px" : "24px",
              marginTop: "0.5rem",
            }}
            onClick={() => {
              setShowNotificationNote(true);
            }}
          >
            {shouldShowNotes && (
              <Button
                sx={{
                  minWidth: "0",
                  background: "transparent",
                  border: "none",
                  boxShadow: "none",
                  padding: "0",
                  ":hover": {
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                  },
                }}
              >
                <NotesBadge
                  unread={unReadNotification?.unread}
                  assigned={unReadNotification?.assigned}
                >
                  <EventNotesNotification />
                </NotesBadge>
              </Button>
            )}
          </Box>
        </Tooltip>
      </ClickAwayListener>
      {positionOpen && (
        <EventNotesPositionModal
          LastActivity={LastActivity}
          open={positionOpen}
          onClose={handlePositionClose}
          updatedChatMetaData={updatedChatMetaData?.filter(
            (item) => item.eventId === selectedEventId,
          )}
        />
      )}
    </>
  );
};

export default EventNotesNotificationTooltip;